(function () {
  var ratesCache = {};
  var configs = {};
  var viewed = {};
  var lastSignature = {};

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function clean(text) {
    return (text || '').replace(/\s+/g, ' ').trim();
  }

  function parseJsonScript(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (error) {
      console.warn('Failed to parse shipping estimate data:', error);
      return null;
    }
  }

  function loadRates(url) {
    if (!url) return Promise.reject(new Error('Missing shipping rates URL'));
    if (!ratesCache[url]) {
      ratesCache[url] = fetch(url, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Failed to load shipping rates');
        return response.json();
      });
    }
    return ratesCache[url];
  }

  function formatMoney(cents, currency, showCurrencyCode) {
    var amount = (Number(cents) || 0) / 100;
    var code = currency || 'USD';
    try {
      var formatted = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 2,
      }).format(amount);
      return showCurrencyCode ? formatted + ' ' + code : formatted;
    } catch (error) {
      return '$' + amount.toFixed(2) + (showCurrencyCode ? ' ' + code : '');
    }
  }

  function getCurrentPack(sectionId, config) {
    var root = document.getElementById('MainProduct-' + sectionId);
    var selected = root ? root.querySelector('.pack-option--selected') : null;
    var pack = selected ? selected.dataset.pack : '';
    pack = pack || window.__infCurrentPack || 'single';
    return config.packs && config.packs[pack] ? pack : 'single';
  }

  function getSiliconeState(config, pack) {
    var checkbox = document.getElementById('addon-silicone-case');
    if (!checkbox || !checkbox.checked || !config.silicone) {
      return { checked: false, quantity: 0, priceCents: 0, weightGrams: 0 };
    }

    var fallbackQty = config.packs && config.packs[pack] ? config.packs[pack].quantity : 1;
    var quantity = parseInt(checkbox.dataset.currentQty || fallbackQty || '1', 10) || 1;
    var unitWeight = Number(config.silicone.weightGrams) || 0;
    if (!unitWeight && config.syncedWeights && config.silicone.handle && config.syncedWeights[config.silicone.handle]) {
      unitWeight = Number(config.syncedWeights[config.silicone.handle].weightGrams) || 0;
    }

    return {
      checked: true,
      quantity: quantity,
      priceCents: (Number(config.silicone.priceCents) || 0) * quantity,
      weightGrams: unitWeight * quantity,
    };
  }

  function findRate(countryRates, grams) {
    if (!countryRates || !countryRates.rates || !countryRates.rates.length) return null;
    var sorted = countryRates.rates.slice().sort(function (a, b) {
      return a.weightLowGrams - b.weightLowGrams;
    });

    for (var i = 0; i < sorted.length; i += 1) {
      var rate = sorted[i];
      var low = Number(rate.weightLowGrams) || 0;
      var high = Number(rate.weightHighGrams) || Number.POSITIVE_INFINITY;
      var isLast = i === sorted.length - 1;
      if (grams >= low && (grams < high || isLast)) return rate;
    }

    return sorted[sorted.length - 1];
  }

  function compute(sectionId, rates) {
    var config = configs[sectionId];
    if (!config || !config.packs) return null;

    var packKey = getCurrentPack(sectionId, config);
    var pack = config.packs[packKey] || config.packs.single;
    if (!pack) return null;

    config.syncedWeights = rates.productWeights || {};

    var silicone = getSiliconeState(config, packKey);
    var productCents = Number(pack.priceCents) || 0;
    var itemsCents = productCents + silicone.priceCents;
    var packWeightGrams = Number(pack.weightGrams) || 0;
    if (!packWeightGrams && pack.handle && rates.productWeights && rates.productWeights[pack.handle]) {
      packWeightGrams = Number(rates.productWeights[pack.handle].weightGrams) || 0;
    }
    var weightGrams = packWeightGrams + silicone.weightGrams;
    var countryCode = config.countryCode || '';
    var countryRates = rates && rates.countries ? rates.countries[countryCode] : null;
    var rate = findRate(countryRates, weightGrams);
    var shippingCents = rate ? Number(rate.priceCents) || 0 : null;

    return {
      sectionId: sectionId,
      countryCode: countryCode,
      countryName: (countryRates && countryRates.countryName) || config.countryName || countryCode,
      currency: rates.currency || config.currency || 'USD',
      showCurrencyCode: !!config.showCurrencyCode,
      packKey: packKey,
      packLabel: pack.label || 'BLEShark Nano',
      packQuantity: pack.quantity || 1,
      productCents: productCents,
      itemsCents: itemsCents,
      weightGrams: weightGrams,
      silicone: silicone,
      rate: rate,
      shippingCents: shippingCents,
      totalCents: shippingCents === null ? null : itemsCents + shippingCents,
    };
  }

  function renderDesktop(result) {
    var module = document.querySelector('.m-product-shipping-estimate[data-section-id="' + result.sectionId + '"]');
    if (!module) return;

    var country = module.querySelector('[data-shipping-country]');
    var total = module.querySelector('[data-shipping-total]');
    var breakdown = module.querySelector('[data-shipping-breakdown]');
    var fine = module.querySelector('[data-shipping-fine]');

    module.hidden = false;
    if (country) country.textContent = result.countryName || result.countryCode || 'your region';

    if (result.shippingCents === null) {
      if (total) total.textContent = 'Shipping calculated at checkout';
      if (breakdown) breakdown.textContent = 'Final total appears after checkout confirms your shipping region.';
      if (fine) fine.textContent = '';
      return;
    }

    if (total) total.textContent = formatMoney(result.shippingCents, result.currency, result.showCurrencyCode);
    if (breakdown) breakdown.textContent = 'Standard shipping. Final rate confirmed at checkout.';
    if (fine) fine.textContent = '';
  }

  function renderSticky(result) {
    var bar = document.querySelector('.m-product-sticky-atc[data-section-id="' + result.sectionId + '"]');
    if (!bar) return;

    var price = bar.querySelector('.m-product-sticky-atc__price');
    var note = bar.querySelector('.m-product-sticky-atc__note');

    if (result.shippingCents === null) {
      if (price) price.textContent = formatMoney(result.itemsCents, result.currency, result.showCurrencyCode);
      if (note) note.textContent = 'Shipping calculated at checkout';
      return;
    }

    if (price) price.textContent = 'Est. total ' + formatMoney(result.totalCents, result.currency, result.showCurrencyCode);
    if (note) {
      note.textContent =
        'Incl. ' +
        formatMoney(result.shippingCents, result.currency, result.showCurrencyCode) +
        ' ship to ' +
        (result.countryCode || result.countryName || 'region');
    }
  }

  function track(result) {
    if (!window.InfiSharkAnalytics || typeof window.InfiSharkAnalytics.track !== 'function') return;

    var signature = [
      result.packKey,
      result.countryCode,
      result.shippingCents,
      result.totalCents,
      result.silicone.checked ? result.silicone.quantity : 0,
    ].join('|');

    if (!viewed[result.sectionId]) {
      viewed[result.sectionId] = true;
      window.InfiSharkAnalytics.track('shipping_estimate_viewed', {
        section_id: result.sectionId,
        country: result.countryCode,
        pack: result.packKey,
        shipping_cents: result.shippingCents,
        total_cents: result.totalCents,
      });
    } else if (lastSignature[result.sectionId] && lastSignature[result.sectionId] !== signature) {
      window.InfiSharkAnalytics.track('shipping_estimate_changed', {
        section_id: result.sectionId,
        country: result.countryCode,
        pack: result.packKey,
        shipping_cents: result.shippingCents,
        total_cents: result.totalCents,
        silicone_quantity: result.silicone.checked ? result.silicone.quantity : 0,
      });
    }

    lastSignature[result.sectionId] = signature;
  }

  function refresh(sectionId) {
    var config = configs[sectionId];
    if (!config) return Promise.resolve(null);

    return loadRates(config.ratesUrl)
      .then(function (rates) {
        var result = compute(sectionId, rates);
        if (!result) return null;
        renderDesktop(result);
        renderSticky(result);
        track(result);
        return result;
      })
      .catch(function (error) {
        console.warn('Shipping estimate unavailable:', error);
        return null;
      });
  }

  function refreshSoon(sectionId) {
    window.setTimeout(function () {
      refresh(sectionId);
    }, 120);
  }

  function initModule(module) {
    var sectionId = module.dataset.sectionId;
    if (!sectionId) return;

    var config = parseJsonScript('InfiShippingEstimateData-' + sectionId);
    if (!config) return;

    config.ratesUrl = module.dataset.ratesUrl || config.ratesUrl;
    configs[sectionId] = config;
    refresh(sectionId);
  }

  window.InfiSharkShippingEstimator = {
    refresh: refresh,
    isActive: function (sectionId) {
      return !!configs[sectionId];
    },
  };

  document.addEventListener('infishark:pack-change', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    if (!sectionId) return;
    refreshSoon(sectionId);
  });

  document.addEventListener('infishark:silicone-change', function () {
    Object.keys(configs).forEach(refreshSoon);
  });

  document.addEventListener('change', function (event) {
    var root = event.target.closest && event.target.closest('product-info[id^="MainProduct-"]');
    if (!root) return;
    refreshSoon(root.dataset.section);
  });

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('.m-product-shipping-estimate').forEach(initModule);
  });

  ready(function () {
    document.querySelectorAll('.m-product-shipping-estimate').forEach(initModule);
  });
})();
